<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">绩效基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :disabled="!isEdit"
          :showBtn="false"
          ref="form"
        />
      </div>
      <folded-panel infoName="绩效组成">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.bsPerformanceCompositionList"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell' }"
            :showAdd="editTable.showAdd"
            :border="true"
            :data.sync="tableData"
            :edit-rules="validRules"
            ref="delRow"
            height=""
          >
            <template #toolbar="scope">
              <el-popover
                :ref="scope.row.id"
                placement="top"
                width="180"
              >
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="$refs[scope.row.id].doClose()"
                  >取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope)"
                  >确定
                  </el-button>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  slot="reference"
                ></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button
          class="btn-submit"
          v-if="isEdit"
          @click="submit"
        >提交</el-button>
        <el-button
          class="btn-cancel"
          @click="cancel"
        >取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataTableMixin from "@/mixins/DataTableMixin";
import { parseTime } from "@/utils";
import { getDocumentCode } from "@/views/utils";
import CrudMixin from "@/mixins/CrudMixin";
import initDict from "@/mixin/initDict";

import {
  add,
  edit,
  delBsPerformance,
  queryById
} from "@/api/basic/achievement.js";

export default {
  name: "AchievementForm",
  components: {
    FoldedPanel
  },
  mixins: [DataTableMixin, CrudMixin,initDict],
  data() {
    return {
      delLoading: false,
      isEdit: true,
      tableData: [],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "模式代码",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "input",
            key: "name",
            label: "模式名称",
            maxlength: "100",
            value: "",
            span: 16,
            rules: [
              { required: true, message: "模式名称不能为空", trigger: "blur" }
            ]
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            maxlength: "200",
            value: "",
            placeholder: "请输入备注",
            span: 24
          }
        ]
      },
      validRules: {
        salaryComposition: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      form: {},
      editTable: {
        showNumber: true,
        enableEdit: true,
        showAdd: true,
        bsPerformanceCompositionList: [
          {
            label: "薪资组成",
            prop: "salaryComposition",
            editRender: {
              type: "default",
              name: "ElSelect",
              options: []
            }
          },
          {
            label: "发放频率",
            prop: "issuingFrequency",
            editRender: {
              type: "default",
              name: "ElSelect",
              options: []
            }
          },
          {
            label: "发放时间",
            prop: "issuingTime",
            editRender: {
              name: "ElDatePicker",
              props: { type: "date", valueFormat: "timestamp" }
            },
            formatter: this.formatter
          },
          {
            label: "发放依据",
            prop: "issuingBasis",
            editRender: { type: "default", name: "ElInput" }
          },
          {
            label: "计算公式",
            prop: "computationalFormula",
            editRender: { type: "default", name: "ElInput" }
          },
          {
            label: "备注",
            prop: "remark",
            editRender: {
              type: "textarea",
              name: "ElTextarea",
              maxlength: "500"
            }
          }
        ]
      },
      id: "",
      validateRefNames: ['form','delRow']
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.isEdit = Boolean(this.$route.query.isEdit);
    if (this.id) {
      queryById(this.id).then(res => {
        if (res.code === 200) {
          this.form = res.data.bsPerformanceMode;
          this.tableData = res.data.bsPerformanceCompositionList;
        }
      });
    } else {
      this.form.code = getDocumentCode("JXMS");
    }
    // 薪资组成
    this.getDict("salary").then(res => {
        this.editTable.bsPerformanceCompositionList[this.editTable.bsPerformanceCompositionList.findIndex(ele => ele.prop === 'salaryComposition')].editRender.options = res.data;
      });
      // 发放频率
    this.getDict("pay_type").then(res => {
        this.editTable.bsPerformanceCompositionList[this.editTable.bsPerformanceCompositionList.findIndex(ele => ele.prop === 'issuingFrequency')].editRender.options = res.data;
      });
  },
  methods: {
    submit() {
      if (this.tableData.length < 1) {
        this.$notify({
          title: "请填写绩效组成信息",
          type: "warning",
          duration: 2500
        });
        return
      }
      this.loading = true;
      this._validateForm(this.validateRefNames)
        .then(res => {
          if (this.form.name) {
            this.form.name = this.form.name.trim();
          }
          if (this.id) {
            edit({ bsPerformanceMode: this.form, bsPerformanceCompositionList: this.tableData}).then(() => {
             this.$notify({ title: "操作成功！", type: "success", duration: 2500});
            });
             this.$router.go(-1);
          } else {
            add({ bsPerformanceMode: this.form, bsPerformanceCompositionList: this.tableData}).then(() => {
              this.$notify({ title: "操作成功！", type: "success", duration: 2500});
            });
             this.$router.go(-1);
          }
        }).catch(e => {
          this.loading = false;
        });
    },
    cancel() {
      this.$router.go(-1);
    },
    // 绩效组成删除
    subDelete(id, scope) {
      if (!id) {
        // this.$refs.delRew.deleteRows(scope);
        this.tableData.splice(scope.$index, 1);
      } else {
        delBsPerformance(id).then(res => {
        if (res.code === 200) {
          this.$refs[id].doClose();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
          this.tableData.splice(scope.$index, 1);
        }
      });
      }
    },
    // 绩效组成的时间格式
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 6px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
  }
}
</style>
